import React, { useState, useEffect } from 'react';

interface InputFormProps {
  onSubmit: (inputValue: string) => void;
  isStreaming: boolean;
  initialValue?: string;
}

const InputForm: React.FC<InputFormProps> = ({ onSubmit, isStreaming, initialValue }) => {
  const [ inputValue, setInputValue ] = useState<string>(initialValue || '');

  const handleEnterPress = (e: any) => {
    if (e.key === 'Enter' || e.which === 13) {
      onSubmit(inputValue);
    }
  };

  useEffect(() => {
    if (initialValue !== undefined) {
      setInputValue(initialValue);
    }
  }, [ initialValue ]);

  return (
    <>
      <div className='classify'>
        <div className='classify-header'>
        Item / Product Name
        </div>
        <div className='classify-cont'>
          <div className='classify-cont-sec'>
            <div className='classify-cont-sec-div'>
              <input placeholder='Enter your product name or keywords' className='classify-cont-sec-input' type='text'
                value={inputValue} onChange={(e) => setInputValue(e.target.value)}
                onKeyUp={handleEnterPress}
              />
            </div>
          </div>
        </div>
        <div className='classify-footer'>
          <div className='classify-footer-btn' onClick={() => onSubmit(inputValue)} aria-disabled={isStreaming}>
            <div className='classify-footer-btn-div'>
            Submit
            </div>
          </div>
          <div className='classify-footer-txt'>
          or press Enter
          </div>
        </div>
      </div>
    </>
  );
};

export default InputForm;
